import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard, ValidUuidGuard } from '@shared/router';
import { Route } from 'react-router';

import { transferDetailRoute, transfersPath } from './urls';

const TransferListView = lazyWithReload(() =>
  import('./Pages/TransferList').then((m) => ({ default: m.Container }))
);

const TransferDetailView = lazyWithReload(() =>
  import('./Pages/TransferDetails').then((m) => ({ default: m.TransferDetails }))
);

export const TransferRoutes = (
  <>
    <Route
      path={transfersPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.transfers}>
          <TransferListView />
        </PermissionGuard>
      }
    />
    <Route
      path={transferDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.transferDetail}>
          <ValidUuidGuard paramName="id">
            <TransferDetailView />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    {/* <Route
      path={transferCancelRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.transfersCancel}>
          <TransferCancelView />
        </PermissionGuard>
      }
    /> */}
  </>
);
